import { render, staticRenderFns } from "./additional.vue?vue&type=template&id=1fae48fb"
import script from "./additional.vue?vue&type=script&lang=js"
export * from "./additional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports